import { useRef, useState, useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import * as Yup from "yup";
import { useFormik } from "formik";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
    getPlanCategoryMaterial,
    setPlanCategoryMaterial,
    updatePlanCategoryMaterial,
    deletePlanCategoryMaterial,
    setDataNull2,
} from "../../store/order/slice";
import ActionMenu from "../../components/ActionMenu";
import ModelDelete from "../../components/ModalDelete";
import { Toast } from "primereact/toast";
import "../../assets/scss/theme-base/ModalShowPlanLead.css";
import { Checkbox } from "primereact/checkbox";
import { getDataAll } from "../../store/processings/slice";
import { formatNumber } from "../../components/utils";
import ModalProcessings from "./ModalProcessing";
import { deleteManyRequest } from "../../store/processings/slice";
import { Paginator } from "primereact/paginator";
import { deleteProcessing } from "../../store/processings/slice";

export const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
};

function ModalShowCategoryMaterial({ isShow, onHide, productId }) {
    const [showNewPlanFields, setShowNewPlanFields] = useState(false);
    const toast = useRef(null);
    const [modalDelete, setModalDelete] = useState(false);
    const [rowData, setRowData] = useState();
    const [isEditMode, setIsEditMode] = useState(false);
    const [checked, setChecked] = useState(false);
    const [openModalUpdate, setOpenModalUpdate] = useState(false);
    const [selectedProducts, setSelectedProducts] = useState(null);
    const [rows, setRows] = useState(10);
    const [first, setFirst] = useState(0);
    const dispatch = useDispatch();
    const {
        planCategoryMaterialData,
        updatePlanCategoryMaterialData,
        deletePlanCategoryMaterialData,
        errorDeletePlanCategoryMaterial,
        addPlanCategoryMaterialData,
        errorAddPlanCategoryMaterial,
        errorUpdatePlanCategoryMaterial,
        processingData,
        insertData,
        deleteData,
        updateData,
    } = useSelector(
        (state) => ({
            planCategoryMaterialData: state.Production.planCategoryMaterialData,
            updatePlanCategoryMaterialData:
                state.Production.updatePlanCategoryMaterialData,
            deletePlanCategoryMaterialData:
                state.Production.deletePlanCategoryMaterialData,
            errorDeletePlanCategoryMaterial:
                state.Production.errorDeletePlanCategoryMaterial,
            addPlanCategoryMaterialData:
                state.Production.addPlanCategoryMaterialData,
            errorAddPlanCategoryMaterial:
                state.Production.errorAddPlanCategoryMaterial,
            errorUpdatePlanCategoryMaterial:
                state.Production.errorUpdatePlanCategoryMaterial,
            processingData: state.Processings.processingData,
            insertData: state.Processings.insertData,
            deleteData: state.Processings.deleteData,
            updateData: state.Processings.updateData,
        }),
        shallowEqual
    );

    const validationSchema = Yup.object({
        time: Yup.string().required("Giá trị này là bắt buộc"),
        machining: Yup.string().required("Giá trị này là bắt buộc"),
    });

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            time: "",
            machining: "",
            productId: productId,
            type: "machining",
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            const formattedValues = {
                ...values,
                time: values.time ? values.time.toISOString() : "",
            };

            if (isEditMode && rowData) {
                dispatch(
                    updatePlanCategoryMaterial({
                        id: rowData.id,
                        data: formattedValues,
                    })
                );
            } else {
                dispatch(setPlanCategoryMaterial(formattedValues));
            }
            setShowNewPlanFields(false);
            setIsEditMode(false);
            formik.resetForm();
        },
    });

    useEffect(() => {
        if (isShow && productId) {
            dispatch(
                getDataAll({
                    page: 1,
                    limit: 100,
                    productId,
                    // type: "machining",
                })
            );
        }
    }, [dispatch, isShow, productId, insertData, deleteData, updateData]);

    useEffect(() => {
        if (insertData || updateData || deleteData) {
            dispatch(
                getDataAll({
                    page: 1,
                    limit: 100,
                    productId,
                    // type: "machining",
                })
            );
            dispatch(setDataNull2());
        }
    }, [dispatch, insertData, deleteData, updateData]);

    const handleDelete = (rowData) => {
        setModalDelete(true);
        setRowData(rowData);
    };

    const acceptDelete = () => {
        if (rowData && rowData !== undefined) {
            const id = rowData.id;
            if (id !== undefined) {
                dispatch(deleteProcessing({ id }));
            }
            setModalDelete(false);
        }
    };

    useEffect(() => {
        if (addPlanCategoryMaterialData) {
            toast.current?.show({
                severity: "success",
                summary: "Thành công",
                detail: "Thêm thành công",
                life: 3000,
            });
            dispatch(setDataNull2());
        }
    }, [dispatch, addPlanCategoryMaterialData]);

    useEffect(() => {
        if (errorAddPlanCategoryMaterial) {
            toast.current?.show({
                severity: "error",
                summary: "Thất bại",
                detail: errorAddPlanCategoryMaterial?.response?.data?.message,
                life: 3000,
            });
            // dispatch(setDataNull2());
        }
    }, [dispatch, errorAddPlanCategoryMaterial]);

    useEffect(() => {
        if (updatePlanCategoryMaterialData) {
            toast.current?.show({
                severity: "success",
                summary: "Thành công",
                detail: "Sửa thành công",
                life: 3000,
            });
            dispatch(setDataNull2());
        }
    }, [dispatch, updatePlanCategoryMaterialData]);

    useEffect(() => {
        if (errorUpdatePlanCategoryMaterial) {
            toast.current?.show({
                severity: "error",
                summary: "Thất bại",
                detail: errorUpdatePlanCategoryMaterial?.response?.data
                    ?.message,
                life: 3000,
            });
            // dispatch(setDataNull2());
        }
    }, [dispatch, errorUpdatePlanCategoryMaterial]);

    useEffect(() => {
        if (deletePlanCategoryMaterialData) {
            toast.current?.show({
                severity: "success",
                summary: "Thành công",
                detail: "Xóa thành công",
                life: 3000,
            });
            dispatch(setDataNull2());
        }
    }, [dispatch, deletePlanCategoryMaterialData]);

    useEffect(() => {
        if (errorDeletePlanCategoryMaterial) {
            toast.current?.show({
                severity: "error",
                summary: "Thất bại",
                detail: errorDeletePlanCategoryMaterial.response.data.message,
                life: 3000,
            });
            // dispatch(setDataNull2());
        }
    }, [dispatch, errorDeletePlanCategoryMaterial]);

    const actionBodyTemplate = (rowData) => {
        return (
            <ActionMenu
                onDelete={() => handleDelete(rowData)}
                onEdit={() => handleEdit(rowData)}
            />
        );
    };

    const handleEdit = (rowData) => {
        setRowData(rowData);
        setIsEditMode(true);
        setOpenModalUpdate(true);
        // formik.setValues({
        //     time: new Date(rowData.time),
        //     machining: rowData.machining,
        //     productId: productId,
        //     type: "machining",
        //     note: rowData.note,
        //     finishMachining: rowData.finishMachining,
        // });
        // setShowNewPlanFields(true);
    };
    const handleSelectionChange = (e) => {
        const selected = e.value || [];

        const updatedSelection = [...selected];

        const uniqueSelection = Array.from(
            new Map(updatedSelection.map((item) => [item.id, item])).values()
        );

        setSelectedProducts(uniqueSelection);
    };
    const handleDeleteMany = () => {
        if (selectedProducts?.length > 0) {
            dispatch(
                deleteManyRequest({
                    type: "material",
                    ids: selectedProducts?.map((item) => item.id),
                })
            );

            setSelectedProducts([]);
        }
    };
    const onPageChange = (event) => {
        setFirst(event.first);
        setRows(event.rows);
    };
    return (
        <Dialog
            header={
                <div className="flex justify-content-between align-items-center">
                    <p>Kế hoạch sản xuất Leadtime hạng mục gia công</p>
                    {selectedProducts?.length > 0 && (
                        <Button
                            label="Xóa"
                            style={{ height: "35px" }}
                            onClick={() => handleDeleteMany()}
                        />
                    )}
                </div>
            }
            visible={isShow}
            style={{ width: "70vw" }}
            className="responsive-dialog"
            onHide={() => {
                formik.resetForm();
                setIsEditMode(false);
                setShowNewPlanFields(false);
                dispatch(setDataNull2());
                setChecked(false);
                onHide();
            }}
            footer={
                false
                // <div>
                //     <Button
                //         label="Hủy"
                //         severity="secondary"
                //         className="p-button-text"
                //         onClick={() => {
                //             formik.resetForm();
                //             setIsEditMode(false);
                //             setShowNewPlanFields(false);
                //             onHide();
                //             dispatch(setDataNull2());
                //         }}
                //     />
                //     <Button
                //         label="Lưu"
                //         type="button"
                //         onClick={() => formik.handleSubmit()}
                //     />
                // </div>
            }
        >
            <Toast ref={toast} />
            <DataTable
                emptyMessage="Không có dữ liệu"
                value={processingData?.data?.items || []}
                tableStyle={{ minWidth: "40rem" }}
                onSelectionChange={handleSelectionChange}
                selectionMode="checkbox"
                selection={selectedProducts || []}
            >
                <Column selectionMode="multiple"></Column>
                <Column
                    header="YCVT sô BRAVO"
                    field="price"
                    style={{ width: "15%", minWidth: "200px" }}
                    body={(rowData) => (
                        <div>{rowData?.Material?.materialRequestNumber}</div>
                    )}
                ></Column>
                <Column
                    header="YCVT số PR"
                    field="materialRequestNumber"
                    style={{ width: "15%", minWidth: "120px" }}
                    body={(rowData) => (
                        <div>{rowData?.Material?.materialRequestNumberPr}</div>
                    )}
                ></Column>
                <Column
                    field="Classification"
                    header="Phân loại"
                    style={{ width: "10%", height: "40px" }}
                    body={(rowData) => rowData?.Material?.Classification?.name}
                ></Column>
                <Column
                    field="name"
                    header="Tên VT"
                    style={{ width: "15%", height: "40px" }}
                    body={(rowData) => rowData?.Material?.name}
                ></Column>
                <Column
                    field="quantity"
                    header="SL"
                    style={{ width: "10%", height: "40px" }}
                ></Column>
                <Column
                    field="price"
                    header="Giá"
                    style={{ width: "5%", height: "40px" }}
                    body={(rowData) => formatNumber(rowData?.Material?.price)}
                ></Column>
                <Column
                    field="unit"
                    header="Đơn vị"
                    style={{ width: "10%", height: "40px" }}
                    body={(rowData) => rowData?.Material?.unit}
                ></Column>
                <Column
                    field="type"
                    header="Loại"
                    style={{ width: "10%", height: "40px" }}
                    body={(rowData) =>
                        rowData?.Material?.type === "NVL"
                            ? "Nguyên vật liệu"
                            : "Gia công"
                    }
                ></Column>
                <Column
                    field="isDone"
                    header="Tình trạng"
                    style={{ width: "10%", height: "40px" }}
                    body={(rowData) =>
                        rowData?.Material?.isDone ? "Done" : "Chưa done"
                    }
                ></Column>
                <Column
                    field="isFinished"
                    header="Đã về"
                    style={{ width: "10%", height: "40px" }}
                    body={(rowData) =>
                        rowData?.isFinished ? "Đã về" : "Chưa về"
                    }
                ></Column>
                <Column
                    field="note"
                    header="Ghi chú"
                    style={{ width: "50%" }}
                    alignHeader={"center"}
                    align={"center"}
                    body={(rowData) => rowData?.Material?.description}
                ></Column>
                <Column
                    field="action"
                    body={actionBodyTemplate}
                    style={{ minWidth: "100px", padding: "0", height: "50px" }}
                />
            </DataTable>
            <div className="card">
                <Paginator
                    first={first}
                    rows={rows}
                    totalRecords={processingData?.data?.totalItems}
                    rowsPerPageOptions={[10, 20, 30, 100, 200, 500]}
                    onPageChange={onPageChange}
                />
            </div>
            <ModelDelete
                visible={modalDelete}
                setVisible={setModalDelete}
                accept={acceptDelete}
            />
            {showNewPlanFields && (
                <div className="mt-2 flex justify-content-between gap-2">
                    <div className="flex flex-column" style={{ width: "48%" }}>
                        <Calendar
                            id="time"
                            name="time"
                            dateFormat="dd/mm/yy"
                            value={formik.values.time}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            placeholder="Chọn ngày"
                        />
                        {formik.touched.time && formik.errors.time ? (
                            <small className="p-error">
                                {formik.errors.time}
                            </small>
                        ) : null}
                    </div>
                    <div className="flex flex-column" style={{ width: "18%" }}>
                        <InputText
                            id="machining"
                            name="machining"
                            value={formik.values.machining}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            placeholder="Nhập số lượng"
                        />
                        {formik.touched.machining && formik.errors.machining ? (
                            <small className="p-error">
                                {formik.errors.machining}
                            </small>
                        ) : null}
                    </div>
                    <div className="flex flex-column" style={{ width: "28%" }}>
                        <InputText
                            id="note"
                            name="note"
                            value={formik.values.note}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            placeholder="Ghi chú"
                        />
                    </div>
                    <div
                        className="flex align-items-center"
                        style={{ width: "36%" }}
                    >
                        <Checkbox
                            id="finishMachining"
                            name="finishMachining"
                            checked={formik.values.finishMachining}
                            onChange={(e) =>
                                formik.setFieldValue(
                                    "finishMachining",
                                    e.checked
                                )
                            }
                        />
                    </div>
                </div>
            )}
            {/* {!showNewPlanFields && (
                <Button
                    type="button"
                    style={{ marginTop: "1rem" }}
                    label="Thêm dòng"
                    onClick={() => setShowNewPlanFields(true)}
                />
            )} */}
            <ModalProcessings
                visible={openModalUpdate}
                onHide={() => setOpenModalUpdate(false)}
                rowData={rowData}
                toast={toast}
            />
        </Dialog>
    );
}

export default ModalShowCategoryMaterial;
